// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dbca01ee","455":"ad714dd0","977":"c2d0ad83"}[chunkId] + ".chunk.js";
};